export default {
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'cross',
            snap: true,
            crossStyle: {
                color: '#999'
            }
        }
    },
    legend: {},
    xAxis: [
        {
            type: 'category',
            axisPointer: {
                type: 'shadow'
            }
        }
    ],
    yAxis: [],
    series: []
}